"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _commonReact = require("@devsta/common-react");

var _basePath = _interopRequireDefault(require("../common/constants/basePath"));

var _Organisation = _interopRequireDefault(require("./Organisation"));

var _SubBrand = _interopRequireDefault(require("./SubBrand"));

var _BrandInfo = _interopRequireDefault(require("./BrandInfo"));

var _ManageSubscription = _interopRequireDefault(require("./ManageSubscription"));

var _Team = _interopRequireDefault(require("./Team"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ManageSubscriptionComponent = (0, _commonReact.requiresPermission)({
  ComponentToRender: _ManageSubscription.default,
  requiredPermission: 'MANAGE_ORGANISATION',
  isRoute: true,
  Fallback: _commonReact.NotFound
});
var _default = [{
  exact: true,
  component: _Organisation.default,
  path: "".concat(_basePath.default, "/")
}, {
  component: _BrandInfo.default,
  path: "".concat(_basePath.default, "/brand/edit/:id?")
}, {
  component: _SubBrand.default,
  path: "".concat(_basePath.default, "/brand/:id")
}, {
  component: ManageSubscriptionComponent,
  path: "".concat(_basePath.default, "/manage-subscription/")
}, {
  component: _Team.default,
  path: "".concat(_basePath.default, "/team/:id")
}];
exports.default = _default;